const state = {
  IMAGE: ['png', 'gif', 'jpg', 'jpeg'],
  VIDEO: ["mp4", "3gp", "ogg", "webm"],
  AUDIO: ["ogg", "mp3", "wav"],
  shareFileType: '',
}
const mutations = {
  SET_SHAREFILETYPE(state, shareFileType) {
    state.shareFileType = shareFileType
  },
}
const actions = {
  SET_SHAREFILETYPE({ state, commit }, name) {
    let type = name.substring(name.lastIndexOf('.') + 1)
    if (state.IMAGE.includes(type)) {
      commit('SET_SHAREFILETYPE', 0)
    } else if (state.VIDEO.includes(type)) {
      commit('SET_SHAREFILETYPE', 1)
    } else if (state.AUDIO.includes(type)) {
      commit('SET_SHAREFILETYPE', 2)
    } else {
      commit('SET_SHAREFILETYPE', 127)
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
